<template>
    <form id="form-users-index" v-on:submit.prevent="validateBeforeSubmit">
        <div class="form-group">
            <ejs-autocomplete name="profile" v-model="formData.profile" data-msg-containerid="formUsersError1"
                              :highlight='1' :ignoreAccent='1' :dataSource='profileList' :fields='fieldsProfileList'
                              :showPopupButton='true' cssClass="e-outline" placeholder="Perfil:"></ejs-autocomplete>
            <div id="formUsersError1"></div>
        </div>
        <div class="form-group">
            <ejs-textbox name="name" v-model="formData.name" placeholder="Nombre:"
                         data-msg-containerid="formUsersError2"></ejs-textbox>
            <div id="formUsersError2"></div>
        </div>
        <div class="form-group">
            <ejs-textbox name="email" v-model="formData.email" placeholder="E-mail:" type="email"
                         data-msg-containerid="formUsersError3"></ejs-textbox>
            <div id="formUsersError3"></div>
        </div>
        <div class="form-group">
            <ejs-textbox name="identification" v-model="formData.identification" placeholder="Cédula:"
                         data-msg-containerid="formUsersError4"></ejs-textbox>
            <div id="formUsersError4"></div>
        </div>
        <div class="form-group">
            <ejs-checkbox name="check_sso" v-model="formData.check_sso" id="check_sso"></ejs-checkbox>
            <ejs-textbox type="email" style="width: 90% !important;margin: 0;" :readonly="!formData.check_sso" name="email_sso"
                         v-model="formData.email_sso" placeholder="Ingresa el usuario corporativo:"
                         data-msg-containerid="formUsersError5"></ejs-textbox>
        </div>
        <div id="formUsersError5"></div>
        <ejs-progressbutton type='submit' cssClass="e-primary" ref="progressBtnFormUsers" :disabled="disabledButton">{{
                $t('textBtn.btnSend')
            }}
        </ejs-progressbutton>
    </form>
</template>
<script>
import axios from 'axios'
import {ProgressButtonPlugin} from "@syncfusion/ej2-vue-splitbuttons";

Vue.use(ProgressButtonPlugin);

export default {
    name: "users-index",
    props: ["data"],
    data() {
        return {
            profileList: [],
            fieldsProfileList: {text: "perfil", value: "id"},
            formData: {
                id: '',
                profile: '',
                name: '',
                email: '',
                identification: '',
                email_sso: '',
                check_sso: false,
            },
            disabledButton: false,
            optionsFormUsers: {
                rules: {
                    'profile': {
                        required: [true, "* Campo perfil requerido."]
                    },
                    'name': {
                        required: [true, "* Campo nombre requerido."],
                    },
                    'email': {
                        required: [true, "* Campo e-mail requerido."],
                        email: [true, "* El e-mail ingresado no es válido."],
                    },
                    'identification': {
                        required: [true, "* Campo cédula requerido."],
                    },
                    'email_sso': {
                        email: [true, "* El e-mail corporativo ingresado no es válido."],
                    }
                }
            },
        }
    },
    mounted: function () {
        this.formObjUsers = new FormValidator('#form-users-index', this.optionsFormUsers);
    },
    methods: {
        initUsersEdit: function () {
            axios.post('/auth/users/getProfileList').then(response => {
                this.profileList = response.data;
                if (this.data) {
                    this.formData.id = this.data.id;
                    this.formData.profile = this.data.profiles_id;
                    this.formData.name = this.data.name;
                    this.formData.email = this.data.email;
                    this.formData.identification = this.data.documento;
                    this.formData.check_sso = (this.data.email_sso != null);
                    this.formData.email_sso = ((this.data.email_sso != null) ? this.data.email_sso:"")
                }
            });
        },
        validateBeforeSubmit: function () {
            let formStatus = this.formObjUsers.validate();
            if (formStatus) {
                this.disabledButton = true;
                this.$refs.progressBtnFormUsers.enable;
                var url = (this.data) ? '/auth/users/getUsersUpdate' : '/auth/users/getUsersAdd';
                axios.post(url, {
                    data: this.formData,
                }).then(response => {
                    this.disabledButton = false;
                    Vue.prototype.$eventHub.$emit('showToastNotification', response.data);
                    if (response.data.status === 'success') {
                        this.formObjUsers.element.reset();
                        Vue.prototype.$eventHub.$emit('onResetStructuringUsers');
                        Vue.prototype.$eventHub.$emit('closeSidebarClick');
                    }
                }).catch(error => {                 
                    Vue.prototype.$eventHub.$emit('showToastNotification', {
                        status: 'error',
                        message: error.response.data.message || 'Error al procesar la solicitud.'
                    });
                }).finally(() => {
                    this.disabledButton = false;
                });
            }
        },
        progress: function () {
            if (this.disabledButton === false) {
                this.$refs.progressBtnFormUsers.stop();
            }
        }
    },
    created() {
        this.initUsersEdit();
    }
}
</script>
